// URLS
// export const BASE_URL = "https://api-stage.wifiattendance.com/"; //stage
export const BASE_URL = "https://api.wifiattendance.com/"; //live
//
// export const BASE_URL = 'https://wifiattendancecloud.azurewebsites.net/'
// export const BASE_URL = "http://3.137.74.85:8080/";/
// export const BASE_URL_IN = "http://192.168.1.37:3017/api/v1/";
// export const BASE_URL_IN = "http://203.129.225.99:3016/api/v1/";
// export const BASE_URL_INVENTORY_SOCKET = "http://203.129.225.99:3017"

// export const BASE_URL_IN = "https://staging.crm-api.wifiattendance.com:3016/api/v1/";
// export const BASE_URL_INVENTORY_SOCKET = "https://zamzam.crm-api.wifiattendance.com:3016"
export const BASE_URL_INVENTORY_SOCKET = `${localStorage.getItem(
  "CRMUrlNode"
)}`;

export const OFFECE_CALLER_BASE_URL = "https://phonebook.redbytes.in/";

export const Mail = "http://192.168.1.31";
//export const BASE_URL = "http:/ / 3.137.74.85: 8080 / ";

// export const COUNTRY_LIST = 'https://restcountries.com/v3.1/all'

// DEVELOPEMENT_URL

// export const DEVELOPEMENT_URL = "https://18.188.42.141/";
export const BASE_URL_DEVELOPEMENT_URL_IMAGES =
  "http://3.137.74.85:8080/assets/uploads/";

export const BASE_URL_CHATADMIN =
  "https://cloudxperte.crm-api.wifiattendance.com:3016/";

// export const BASE_URL_CHATADMIN = "http://192.168.1.23:3016/";

// Image URLS
export const BASE_URL_LIVE_IMAGES =
  "https://api.wifiattendance.com/assets/uploads/";

// export const BASE_URL="http://wifiapi.cloudxperte.com:8080/"
// export const BASE_URL_CHAT = 'http://192.168.1.38:3015'
//export const BASE_URL = "http://wifiapi.cloudxperte.com:8080/"; // zam zam

export const BASE_URL_CHAT = "https://chat.wifiattendance.com:3015";
export const BASE_URL_CHAT_Image = "https://chat.wifiattendance.com";

// export const BASE_URL_Offoce_caller =
//   "https://cloudxperte.crm-api.wifiattendance.com:3016";

export const BASE_URL_Offoce_caller = localStorage.getItem("CRMUrlNode");
// export const BASE_URL_IN = "https://zamzam.crm-api.wifiattendance.com:3016/api/v1/";GET_RESTAURANT
export const BASE_URL_IN = `${localStorage.getItem("CRMUrlNode")}api/v1/`;
// ||
// "https://cloudxperte.crm-api.wifiattendance.com:3016";

export const PROFILR_iMG_PATH = "assets/uploads/";

const LOGIN_PATH = "api/authentication/";
const USER_PATH = "api/users/";
const ATTENDANCE_PATH = "api/attendance/";
const TASK_PATH = "api/taskmanagement/";
const TIME_SHEET = "api/timesheet/";
const PRJECT_PATH = "api/Project/";
const DASHBOARD_PATH = "api/dashboard/";
const ORGANIZATION_PATH = "api/organization/";
const PROFILE_PATH = "api/myprofile/";
const PROJECT_PATH = "api/project/";
const ROLE_PATH = "api/roles/";
const COMPLIANCE = "compliance/";
const HOLIDAY_PATH = "api/holiday/";
const LOCATION = "api/location/";

// const INVOICE_PATH = "api1/invoice/";
// const INCOME_PATH = "api/income/";
// const EXPENSE_PATH = "api/expense/";
// const PRODUCT_PATH = "api/products/";
// const PURCHASE_PATH = "api/purchase/";
// const REGISTER_PATH = "api/users/";
const ADMIN_PATH = "api/admin/";
// const ACCOUNT_PATH = "api/ledger/";
// const INVOICENO_PATH = "api1/invoice/";
// const CLIENT_PATH = "api/clients/";
// const INVOICE_SETTINGS = "api/settings/";
// const ENTITY_PATH = "api/entities/";

// const LOGIN_PATH = "api/authentication/";
const INVOICE_PATH = "api1/invoice/";
const INCOME_PATH = "api/income/";
const EXPENSE_PATH = "api/expense/";
const PRODUCT_PATH = "api1/productspriston/";
const PURCHASE_PATH = "api1/purchasepriston/";
// const PROFILE_PATH = "api/admin/";
const REGISTER_PATH = "api/users/";
const ACCOUNT_PATH = "api/ledger/";
const INVOICENO_PATH = "api1/invoice/";
const CLIENT_PATH = "api/clients/";
const INVOICE_SETTINGS = "api/settings/";
const ENTITY_PATH = "api/entities/";

const ApiConfig = {
  BASE_URL_FOR_IMAGES: BASE_URL + "assets/uploads/",
  BASE_URL_FOR_IMAGES_Clinet: BASE_URL,
  BASE_URL: BASE_URL,
  BASE_URL_IN: BASE_URL_IN,
  BASE_URL_INVENTORY_SOCKET: BASE_URL_INVENTORY_SOCKET,
  BASE_URL_CHATADMIN: BASE_URL_CHATADMIN,
  //  ============= PROFILE API =============================
  GET_PROFILE: BASE_URL + PROFILE_PATH + "getprofile",
  EDIT_PERSONALDATA: BASE_URL + PROFILE_PATH + "editpersonaldtls",
  EDIT_EMPLOYEDATA: BASE_URL + PROFILE_PATH + "editemployeecontactdtl",
  MY_DAIRY: BASE_URL + "getuseractivity",
  EMPLOYEE_STATUS: BASE_URL + "activeanddeactiveuser",
  DELETE_EMPLOYEE: BASE_URL + "deleteuser",
  EDIT_EMP_PERSONAL_DETLS: BASE_URL + "editemployeepersonaldtls",
  EDIT_EMP_PROFESSIONAL_DTLS: BASE_URL + "editemployeeprofessionaldtls",
  GET_USER_PERMISSIONS: BASE_URL + "api/users/getuserpermissions/", // pass empId
  GET_PROFILE_WORK_DETAILS: BASE_URL + "api/myprofile/getprofileworkdetails",
  GET_COUNTRY_LIST: BASE_URL + "getcountries",
  STATE_LIST: BASE_URL + "getstates?countryId=",
  GET_CITIES_LIST: BASE_URL + "getcities?stateId=",
  GET_EMPLOYEE: BASE_URL + "getemployee",
  UPDATE_EMP: BASE_URL + "employeeedit",
  GET_YEARS_FROM_JOINING: BASE_URL + "api/holiday/getyearslist?EmpId=",
  GET_MANAGE_PERMISSIONS: BASE_URL + 'api/settings/getpermissionlist?type=',
  ADD_UPDATE_PERMISSIONS: BASE_URL + 'api/Settings/UpsertPermission',
  DELETE_PERMISSION: BASE_URL + 'api/settings/deletepermission?id=',

  /*========================= ledger ===========================*/
  GET_LEDGER_LIST: BASE_URL + "api/ledger/new/getledgermasterlist",
  GET_PRIMARY_LEDGER_LIST: BASE_URL + "api/ledger/new/getprimaryledgerlist",
  GET_LEDGER_GROUP_LIST: BASE_URL + "api/ledger/new/getledgergrouplist",
  CREATE_PRIMARY_LEDGER: BASE_URL + "api/ledger/new/createprimaryledger",
  DELETE_PRIMARY_LEDGER: BASE_URL + "api/ledger/new/deleteprimaryledgerbyid",
  EDIT_PRIMARY_GROUP: BASE_URL + "api/ledger/new/editprimaryledgergroup",
  CREATE_LEDGER_GROUP: BASE_URL + "api/ledger/new/createledgergroup",
  DELETE_LEDGER_GROUP_ID: BASE_URL + "api/ledger/new/deleteledgergroupbyid",
  EDIT_LEDGER_GROUP: BASE_URL + "api/ledger/new/editledgergroup",
  CREATE_UPDATE_LEDGER_MASTER:
    BASE_URL + "api/ledger/new/createandupdateledger",
  GET_EDIT_MASTER_BY_ID: BASE_URL + "api/ledger/new/getledgermasterbyid",
  GET_ALL_TRANSACTION: BASE_URL + "api/ledger/new/getledgermastertransactions",
  CREATE_TRANSACTION: BASE_URL + "api/ledger/new/createledgertransactionentry",
  CREATE_MANUAL_LEDGER: BASE_URL + 'api/ledger/journal/manual',
  GET_MASTER_TRANSECTION: BASE_URL + 'api/ledger/new/getledgermastertransactions?id=',
  LEDGER_RECLASSIFICATION: BASE_URL + 'api/ledger/ledger/reclassification',
  GET_PROFIT_AND_LOST_STATEMENT: BASE_URL + 'api/ledger/new/getprofitlossstatement',
  GET_BALANCE_SHEET: BASE_URL + 'api/ledger/new/getbalancesheet',
  GET_TRIAL_BALANCE: BASE_URL + 'api/ledger/new/gettrialbalance',
  //  ============= user API =============================
  CREATE_ACCOUNT: BASE_URL + USER_PATH + "registeruser",
  LOGIN: BASE_URL + LOGIN_PATH + "authenticate",
  VERYFY_OTP: BASE_URL + USER_PATH + "verifyotp",
  REGISTERBUSSNESS: BASE_URL + USER_PATH + "registerbusiness",
  COUNTRY: BASE_URL + LOCATION + "getcountries",
  SECTOR: BASE_URL + LOCATION + "getsectors",
  LOGOUT: BASE_URL + "api/authentication/logout",
  // LOGIN: BASE_URL + LOGIN_PATH + "authenticate",
  FORGET_PASSWORD: BASE_URL + USER_PATH + "forgetpassword",
  CHANGE_PASSWORD: BASE_URL + USER_PATH + "changeuserpassword",
  //  ============= DASHBOARD API =============================
  GET_CHECKIN_CHECKOUT_DATA: BASE_URL + DASHBOARD_PATH + "getcheckincheckout",
  DASHBOARD_ALERT_NOTIFICATIONS:
    BASE_URL + DASHBOARD_PATH + "alertnotifications",
  TIMESHEETCOUNTS: BASE_URL + DASHBOARD_PATH + "timesheetcount",
  TIMESHEETCOUNTS2: BASE_URL + DASHBOARD_PATH + "gettotaltimesheethours",

  // http://localhost:44339/api/dashboard/timesheetcount

  // Invernter Mengemenet //

  // Invernter Print //
  GET_INVENTORY_PRODUCT: 'api/v1/products/menu/items-lookup?shop_id=',
  ADD_Print: BASE_URL_IN + "kitchen/",
  Update_Print: BASE_URL_IN + "kitchen/",
  GET_Print_detalis: BASE_URL_IN + "kitchen/",
  GET_Print_Catagrilist: BASE_URL_IN + "kitchen/unassigned-categories/",
  test_Print: BASE_URL_IN + "kitchen/test-print",
  List_Print: BASE_URL_IN + "kitchen?shop_id=",
  DELETE_Print: BASE_URL_IN + "kitchen/",

  GET_STORE: BASE_URL_IN + "shops/",
  GET_STORE_DROPDOWN: BASE_URL_IN + "shops/storeDropDown/",
  GET_STORE_Status: BASE_URL_IN + "shops/202/status",
  GET_STORE_Status_Change: BASE_URL_IN + "shops/",
  ADD_STORE: BASE_URL_IN + "shops/",
  UPDATE_STORE: BASE_URL_IN + "shops/",
  STORE_Detalis: BASE_URL_IN + "shops/",
  DELETE_STORE: BASE_URL_IN + "shops/",

  // Stock
  GET_STOCK_LIST: BASE_URL_IN + "products/stockList?",
  RESTOCK_UPDATE: BASE_URL_IN + "products/restock",

  // order list
  OrderList: BASE_URL_IN + "order",
  CHANGE_STAUS_ORDER: BASE_URL_IN + "order/status",
  ORDER_VIEW_ID: BASE_URL_IN + "order/",
  CHAT_VIEW: BASE_URL_IN + "order/stats?shop_id=",

  // ManuOn of

  LIST_MENU_ITEM: BASE_URL_IN + "products/categories?",
  UPDATE_MENU_ITEM: BASE_URL_IN + "products/toggle-Active",
  ADDON_ON_OFF_LIST: BASE_URL_IN + "addons/?shop_id=",
  STORE_ON_OFF: BASE_URL_IN + "shops/",
  STORE_STATUS: BASE_URL_IN + "shops/",

  // Discount Item
  ADD_DISCOUNT_CATREGOREY: BASE_URL_IN + "discount",
  UPDATE_DISCOUNT_CATREGOREY: BASE_URL_IN + "discount/",
  GET_DISCOUNT_VIEW: BASE_URL_IN + "discount/",

  // Categorys
  GET_CATEGORY_LIST_DATA: BASE_URL_IN + "category?shop_id=",
  ADD_CATEGORY: BASE_URL_IN + "category",
  UPDATE_RANK: BASE_URL_IN + "category/change-rank-status",

  // parent Categorys
  GET_PARENT_CATEGORY_LIST: BASE_URL_IN + "category/parent?shop_id=",
  PARENT_UPDATE_RANK: BASE_URL_IN + "category/parent/change-rank-status",
  UPDATE_PARENT_CATEGORY: BASE_URL_IN + "category/parent",
  DETAILS_PARENT_CATEGORY: BASE_URL_IN + "category/parent",
  ADD_PARENT_CATEGORY: BASE_URL_IN + "category/parent",
  GET_CATEGORY_LIST: BASE_URL_IN + "category/lookup?",

  // variation
  GET_VARIATION_LIST: BASE_URL_IN + "variants?shop_id=",
  GET_VARIATION_LOOKUP: BASE_URL_IN + "variants/lookup/",
  ADD_VARIATION: BASE_URL_IN + "variants",
  UNIT_MEASUREMNET: BASE_URL_IN + "products/unit_of_measurements",
  UPDATE_VARIATION_RANK: BASE_URL_IN + "variants/change-rank-status",

  // discounts
  GETDICOUNTLIST: BASE_URL_IN + "discount?shop_id=",

  // Taxes
  GET_TAXES_LIST: BASE_URL_IN + "tax/?shop_id=",
  ADD_TAXES: BASE_URL_IN + "tax/",
  TEX_UPDATE_RANK: BASE_URL_IN + "tax/change-rank",
  DETAILS_TAXES: BASE_URL_IN + "tax/",

  // items
  GET_ITEM_LIST: BASE_URL_IN + "products/",
  ADD_UPDATE_ITEM: BASE_URL_IN + "products/",
  TOGGLE_ON_OF: BASE_URL_IN + "products/toggle-available",
  UPDATE_ACTION: BASE_URL_IN + "products/action",
  GET_ADDON: BASE_URL_IN + "addons/lookup/",
  ADD_ADDON: BASE_URL_IN + "addons",
  GET_ADDONS_BY_ID: BASE_URL_IN + "addons/?shop_id=",
  GET_ADDON_FOR_UPDATE: BASE_URL_IN + "addons/", // pass id
  ADD_NEW_TABLE: BASE_URL_IN + "tables",
  TABLES_DATA: BASE_URL_IN + "tables",
  ADD_DISCOUNT: BASE_URL_IN + "tables/discount",
  TABLE_ACTION: BASE_URL_IN + "tables/actions",
  GET_MASTER_AREA: BASE_URL_IN + "tables/areas/master-lookup",
  GET_TABLE_LOCKUP: BASE_URL_IN + "tables/lookup?shop_id=",
  ADD_AREA: BASE_URL_IN + "tables/areas",
  ADD_AREA_DISCOUNT: BASE_URL_IN + "tables/areas/discount",
  AREA_DISCOUNT: BASE_URL_IN + "tables/areas/discount",
  GET_HSN_GST: BASE_URL_IN + "tax/gst",
  IMPORT_PRODUCTS: BASE_URL_IN + "products/import-excel",
  IMPORT_executive: BASE_URL_IN + "order/print-executive-report",
  IMPORT_executive: BASE_URL_IN + "order/print-executive-report",

  //  ============= Attendance API =============================
  // ATTENDANCE_LIST: BASE_URL + ATTENDANCE_PATH + "getmyattendance",
  NewApiATTENDANCE_LIST: BASE_URL + ATTENDANCE_PATH + "getmyattendancemultipunch",
  EMPLOEE_NAME_LIST: BASE_URL + ATTENDANCE_PATH + "getemployeesnames",
  EMPLOYEE_LIST: BASE_URL + ATTENDANCE_PATH + "employeeattlist",
  NewEMPLOYEE_LIST: BASE_URL + ATTENDANCE_PATH + "employeeattlistmultipunch",
  UPDATE_TIME: BASE_URL + ATTENDANCE_PATH + "updateintimeouttime",
  GETINOUT_TIME: BASE_URL + ATTENDANCE_PATH + "getintimeouttime",
  ATTENDANCE_REPORT: BASE_URL + ATTENDANCE_PATH + "attendancereportmultipunch",
  PUNCH_HISTORY: BASE_URL + ATTENDANCE_PATH + "getpuchhistory",
  PUNCH_HISTORY_WITH_SESSION: BASE_URL + 'api/attendance/getpuchhistorymultipunch',
  PUNCH_HISTORY_EXPORT: BASE_URL + ATTENDANCE_PATH + "AttendanceHistoryExport",

  LEAVEAPROVE_LIST: BASE_URL + ATTENDANCE_PATH + "getemployeeapprovelist",
  GET_APPROVE_SUBlIST: BASE_URL + ATTENDANCE_PATH + "getapprovesublist",
  UPDATE_APPRPVELEAVE_LIST: BASE_URL + ATTENDANCE_PATH + "updateapprovelist",
  GET_LEAVE_LIST: BASE_URL + ATTENDANCE_PATH + "getemployeeleaveapplications",
  GET_EMPLOYEE_LEAVE_LIST:
    BASE_URL + ATTENDANCE_PATH + "leaveapplicationsbymanager",
  GET_LEAVE_TYPE: BASE_URL + ATTENDANCE_PATH + "getleavetype",
  GET_LEAVE_STRUCTURE: BASE_URL + ATTENDANCE_PATH + "getleavestructure",
  APPLY_LEAVE: BASE_URL + ATTENDANCE_PATH + "employeeleaveapply",
  APPLY_EMPLOYEE_LEAVE: BASE_URL + ATTENDANCE_PATH + "leaveapplybymanager",
  GET_LEAVE_STRUCTURE_BY_EMPID:
    BASE_URL + ATTENDANCE_PATH + "getleavestructurebyempid",
  GET_BRANCH_NAME_LIST: BASE_URL + "api/organization/location",
  ALL_EMPLOYEE_DOWNLOAD_EXCEL: BASE_URL + "api/attendance/allempattend",
  ATTANDANCE_USER_TRACKING: BASE_URL + "attendance/getusertracking",
  ATTANDANCE_USER_TRACKING_EXPORT: BASE_URL + "attendance/usertrackingexcel",
  GET_LEAVE_SETTING: BASE_URL + "getleavesetting?id=",
  CREATE_AND_UPDATE_LEAVE_SETTING: BASE_URL + "createAndupdateleavesetting",

  GETINOUT_TIME_C: BASE_URL + "me/Attendance/CheckInOut",

  //  ============= Attendance API =============================

  // USER_MANAGEMENT-ROLE-CREATE MODULE
  // GET_ALL_ROLE: BASE_URL + ROLE_PATH + "getroles",
  CHANGE_ROLE_STATUS: BASE_URL + ROLE_PATH + "active",
  ADD_NEW_ROLE: BASE_URL + ROLE_PATH + "createrole",
  UPDATE_ROLE: BASE_URL + ROLE_PATH + "modify",
  GET_EMPLOYEE_NAMES: BASE_URL + "api/attendance/" + "getemployeesnames",
  SEARCH_ROLE_API: BASE_URL + ROLE_PATH + "rolesearch",
  USERSTATUS: BASE_URL + "checkuserstatus",
  // USER_MANAGEMENT-ROLE-CREATE MODULE

  // USER_MANAGEMENT-ROLE-ASSIGN MODULE
  GET_ALL_APPROVE_USERS: BASE_URL + ROLE_PATH + "assignrole/getall",
  GET_ALL_ASSIGN_USERS: BASE_URL + ROLE_PATH + "searchassign",
  GET_ALL_USERNAMES: BASE_URL + USER_PATH + "userlist",
  GET_ALL_ROLE_NAMES: BASE_URL + ROLE_PATH + "getroles",
  ASSIGN_ROLE: BASE_URL + ROLE_PATH + "assignrole",
  EDIT_ASIGN_ROLE: BASE_URL + ROLE_PATH + "editassignrole",
  GET_USER_ROLE_EDIT_DATA: BASE_URL + ROLE_PATH + "getuseroles",
  ASSIGNROLE_DOWNLOAD_EXCEL: BASE_URL + "api/roles/roleassignexcel",
  ROLE_LIST_DOWNLOAD_EXCEL: BASE_URL + "api/roles/roleslistexcel",
  // USER_MANAGEMENT-ROLE-ASSIGN MODULE

  // USER MANAGEMENT => PERMISSIONS
  GET_ALL_PERMISSIONS: BASE_URL + ROLE_PATH + "permissions/getall",
  GER_PERMISSIONS_BY_ROLEID: BASE_URL + ROLE_PATH + "permissions/getbyrole",
  UPDATE_PERMISSIONS: BASE_URL + ROLE_PATH + "permissions/add",
  DELETE_ROLE: BASE_URL + "api/roles/deleterole",

  // USER MANAGEMENT => PERMISSIONS

  //  ====================== Task Management ===========================
  // GET_TASK_LIST: BASE_URL + TASK_PATH + "gettasklist",
  GET_TASK_LIST: BASE_URL + "api/taskmanagement/gettasklist",
  GET_TEAM_TASK_LIST: BASE_URL + TASK_PATH + "getteamtasklists",
  GET_PROJECT_TASK_LIST: BASE_URL + TASK_PATH + "projecttasklist",
  GET_TASK_APPROVE_LIST: BASE_URL + TASK_PATH + "taskapprovelist",
  TASK_APPROVE: BASE_URL + TASK_PATH + "approvetask",
  ADD_TASK: BASE_URL + TASK_PATH + "addtaskorupdatetask",
  GET_TASK_BY_ID: BASE_URL + TASK_PATH + "gettaskbyid",
  EMP_PROJECTS_NAMES: BASE_URL + TASK_PATH + "GetTaskProjectNames",
  PRIORITY_MASTER: BASE_URL + "api/prioritymaster/getpriority",
  GET_TASK_DATIALS: BASE_URL + TASK_PATH + "getemplmonthlytaskdetails",
  //  ====================== TIME - SHEET Management ===========================
  PROJECTS_NAMES: BASE_URL + TIME_SHEET + "AssignedProjectNames",
  PROJECTS_NAMES_FOR_DATE:
    BASE_URL + TIME_SHEET + "getprojectlistfordate?Date=",

  TIME_SHEET_DETAILS: BASE_URL + TIME_SHEET + "timesheetdetails",
  GET_MP_TASK: BASE_URL + TIME_SHEET + "getemptask",
  TIMESHEET_LIST: BASE_URL + TIME_SHEET + "timesheetentrylist",
  UPDATE_TIMESHEET: BASE_URL + TIME_SHEET + "updatetimesheet",
  ADD_TIMESHEET: BASE_URL + TIME_SHEET + "entertimesheet",
  TIME_CALENDER_HISTORY: BASE_URL + TIME_SHEET + "gettimesheethistory",
  APPROVED_PROJECT: BASE_URL + TIME_SHEET + "approveandreject",
  TIMESHEET_HISTORY: BASE_URL + TIME_SHEET + "TimesheetHistory",
  TIMESHETT_APPROVECOUNT: BASE_URL + TIME_SHEET + "TimeSheetApprcount",
  TIMESHEET_APPROVE_DETAILS:
    BASE_URL + TIME_SHEET + "TimesheetApprDetails?sort=",
  TIMESHEET_APPROVE_REJECT: BASE_URL + TIME_SHEET + "ApproveAndReject",
  DELETE_TIME_SHEET: BASE_URL + TIME_SHEET + "deletetimesheet",
  TIME_SHEET_UPDATE_VIEW: BASE_URL + TIME_SHEET + "gettimesheetdetails",
  MULTIPLE_TIMESHEET_APPROVE:
    BASE_URL + TIME_SHEET + "multipleapproveandreject",
  GET_REASONS: BASE_URL + "api/taskmanagement/gettasksreasons",
  UPADTE_TASK_WITH_REASON: BASE_URL + "api/taskmanagement/savetaskconfrimation",

  //  ====================== PRJECT - SHEET Management ===========================
  PROJECT_SCHEDUILE_LIST: BASE_URL + PRJECT_PATH + "ProjectScheduleList",
  PROJECT_RESOURCE_LIST: BASE_URL + PRJECT_PATH + "projectresourcelist",
  PROJECT_TEAM_TASK: BASE_URL + PRJECT_PATH + "projectteamtask",
  GETPROJECT_TEAM_TASK: BASE_URL + PRJECT_PATH + "GetProjectResourceList",

  //  ====================== ORGANIZATION - SHEET Management ===========================
  HOLIDAY_EVENT_API: BASE_URL + ORGANIZATION_PATH + "gethoildayandevents",
  CRATE_ANNOUNCEMENT: BASE_URL + ORGANIZATION_PATH + "createannouncement",
  ORGANIZATION_BRANCH: BASE_URL + ORGANIZATION_PATH + "organizationbranches",
  ORGANIZATION_TEAM: BASE_URL + ORGANIZATION_PATH + "organizationteams",
  EMPLOYEE_NAMES: BASE_URL + ORGANIZATION_PATH + "getemployeesnames",
  MY_ANNOUNCEMENTS: BASE_URL + ORGANIZATION_PATH + "getmyannouncements",
  UPDATE_ANNOUNCEMENTS: BASE_URL + ORGANIZATION_PATH + "updateannoucement",
  DELETE_ANNOUNCEMENTS: BASE_URL + ORGANIZATION_PATH + "deleteanouncement",
  PREVIEW_ANNOUNCEMENTS:
    BASE_URL + ORGANIZATION_PATH + "getannoucementpreviewlist",
  ALL_ANNOUNCEMENTS_LIST:
    BASE_URL + ORGANIZATION_PATH + "getallannoucementlist",
  UPDATE_VIEW_COUNT: BASE_URL + ORGANIZATION_PATH + "updateviewedcount",
  VIEW_MEMBER_LIST: BASE_URL + ORGANIZATION_PATH + "viewmemberlist",
  GET_ORGANIZATION_LIST: BASE_URL + ORGANIZATION_PATH + "getorganization",
  UPDATE_ORGANIZATION: BASE_URL + ORGANIZATION_PATH + "organizationmodify",
  GET_DEPARMENT_LIST: BASE_URL + ORGANIZATION_PATH + "getdepartmentlist",
  DEPARTMENT_MODIFY: BASE_URL + ORGANIZATION_PATH + "departmentmodify",
  GET_DESIGNATION_LIST: BASE_URL + ORGANIZATION_PATH + "designationlist",
  CREATE_DESIGNATION: BASE_URL + ORGANIZATION_PATH + "createdesignation",
  DELETE_DESIGNATION: BASE_URL + ORGANIZATION_PATH + "deletedesignation",
  GET_DESIGNATION: BASE_URL + ORGANIZATION_PATH + "getdesignation",
  GET_MANAGE_LOCATION: BASE_URL + ORGANIZATION_PATH + "location",
  CREATE_LOCATION: BASE_URL + ORGANIZATION_PATH + "createlocation",
  DELETE_LOCATION: BASE_URL + ORGANIZATION_PATH + "deletelocation",

  GET_USER_DETAILS: BASE_URL + ORGANIZATION_PATH + "userdetails",
  CHANGE_USER_STATUS: BASE_URL + ORGANIZATION_PATH + "userstatus",
  GET_MANAGE_SHIFT: BASE_URL + ORGANIZATION_PATH + "manageshift",
  GET_SINGLE_SHIFT: BASE_URL + ORGANIZATION_PATH + "getshiftmaster",
  SHIFT_MASTER_MODIFY: BASE_URL + ORGANIZATION_PATH + "shiftmastermodify",
  GET_ALL_SHIFT: BASE_URL + "api/shiftmaster/getallshift",
  ADD_SHIFT_MASTER: BASE_URL + "api/shiftmaster/addShiftMaster",
  UPDATE_SHIFT_MASTER: BASE_URL + "api/shiftmaster/updateshiftmaster/",
  DELETE_SHIFT_MASTER: BASE_URL + "api/shiftmaster/deleteShift/",
  EDIT_SHIFT_MASTER: BASE_URL + "api/shiftmaster/getshiftbyid?id=",
  CALENDAR_SETTING_ADD: BASE_URL + "api/holiday/calendarsettings",
  GET_CALENDER_SETTING_BY_ROLE:
    BASE_URL + "api/holiday/getcalendarsettings?RoleId=",
  GET_ACEDEMIC_DETAILS: BASE_URL + "api/holiday/getacademicyearslist",
  DELETE_CALENDER_YEAR: BASE_URL + "api/holiday/deleteacademicyear?id=",
  CREATE_ACEDEMIC_YEAR: BASE_URL + "api/holiday/createacademicyear",
  GET_SINGLE_ACEDMIC_YEAR: BASE_URL + "api/holiday/getacademicyear?id=",

  //==============Node apis for chat===============
  SEARCH_ALL: BASE_URL_CHAT + "/search-all?search_key=",
  CREATE_CHATROOM: BASE_URL_CHAT + "/chat/private-chat",
  GET_PRIVATE_CHAT_CONVERSATION:
    BASE_URL_CHAT + "/chat/private-chat/get-conversation?schannel_id=",
  GET_RECENTCHATS: BASE_URL_CHAT + "/chat/private-chat/get-chats-list",
  UPLOAD_CHAT_FILES: BASE_URL_CHAT + "/chat/private-chat/handleUpload",
  PIN_CHAT: BASE_URL_CHAT + "/chat/private-chat/pin-chat",
  UNPIN_CHAT: BASE_URL_CHAT + "/chat/private-chat/unpin-chat",
  SET_STATUS: BASE_URL_CHAT + "/chat/private-chat/change-status",
  GET_FILES: BASE_URL_CHAT + "/chat/private-chat/getFiles?schannel_id=",
  CREATE_SUB_CHANNEL: BASE_URL_CHAT + "/chat/group-chat/create-subchannel",
  CREATE_SUB_CHANNEL_ADDMEMBER:
    "https://chat.wifiattendance.com:3015/chat/add-user-lookup",

  CREATE_Task: BASE_URL + "api/taskmanagement/addtaskorupdatetask",
  CREATE_SERVICE_GROUP: BASE_URL + "api/service/createservicegroup",
  UPDATE_SERVICE_GROUP: BASE_URL + "api/service/servicegroupmodify",
  GET_SERVICE_LIST: BASE_URL + "api/service/getservicesgrouplist",
  GET_SERVICE_WITH_PERIOD: BASE_URL + "api/service/getservices",
  CREATE_SERVICE: BASE_URL + "api/service/create",
  GET_SERVICES_CLIENT: BASE_URL + "api/service/getservices",
  GET_SINGEL_SERVICE: BASE_URL + "api/service/",
  UPDATE_SERVICE: BASE_URL + "api/service/modify",
  CREATE_RATE_TABLE: BASE_URL + "api/feeschart/create",
  UPDATE_RATE_TABLE: BASE_URL + "api/feeschart/modify",
  GET_RATE_RATE_TABLE: BASE_URL + "api/feeschart/getfeescharts",
  GET_SINGLE_RATE: BASE_URL + "api/feeschart/",
  MASTER_DATA: BASE_URL + "api/admin/masterdata",
  // ============ TASK MANAGEMENT (SUB MODULE) ========
  GET_TASK_PROJECTLIST: BASE_URL + "api/taskmanagement/projectlist",
  GET_PROJECT_LIST_ADMIN: BASE_URL + "api/taskmanagement/tasklistbyadmin",
  POST_TASK_BY_ADMIN: BASE_URL + "api/taskmanagement/addtaskbypjtadmin",
  EDIT_TASK_BY_ID: BASE_URL + "api/taskmanagement/getprojecttaskbyid",
  GET_TASK_NAME_MODAL: BASE_URL + "api/taskmanagement/standardtasklist",
  UPDATE_TASK_BY_ADMIN: BASE_URL + "api/taskmanagement/updatetaskbyadmin",
  Delete_Task_By_Id: BASE_URL + "api/taskmanagement/deletetasklist",
  GET_TASK_DOWNLOAD_EXCEL: BASE_URL + "api/taskmanagement/gettaskexcelsheet",
  // Task Allocation list (SUB MODULE) ===========
  GET_TASK_ALLOCATION_LIST: BASE_URL + "api/taskmanagement/taskallocationlist",
  GET_EMPLOYEE_NAME_LIST:
    BASE_URL + "api/taskmanagement/empnamebyprojectassign",
  SAVE_TASK_ALLOCATION: BASE_URL + "api/taskmanagement/taskallocations",
  GET_OUTSOURCE_ALLOCATION_LIST:
    BASE_URL + "api/taskmanagement/empnameoutsourcing",

  // Abort Task (SUB MODULE) ===========
  ABORT_TASK_LIST_DATA: BASE_URL + "api/taskmanagement/aborttasklist",
  ABORT_TASK_POST: BASE_URL + "api/taskmanagement/aborttask",
  ABORT_TASK_DOWNLOAD_EXCEL: BASE_URL + "api/taskmanagement/aborttaskexcel",

  // Hold Task (SUB MODULE) ===========
  HOLD_TASK_LIST: BASE_URL + "api/taskmanagement/holdtasklist",
  HOLD_TASK_CLICK: BASE_URL + "api/taskmanagement/holdtask",
  HOLD_TASK_DOWNLOAD_EXCEL: BASE_URL + "api/taskmanagement/holdtaskexcel",

  // Standard Task (SUB MODULE) ===========
  GET_TEAMS_LIST_STANDARD_TASK: BASE_URL + "api/taskmanagement/getteams",
  ADD_STANDARD_TASK: BASE_URL + "api/taskmanagement/addstandardtask",
  STANDARD_TASK_BY_ID: BASE_URL + "api/taskmanagement/standardtaskbyid",
  UPDATE_STANDARD_TASK_LIST: BASE_URL + "api/taskmanagement/updatestandardtask",
  DELETE_STANDARD_TASK: BASE_URL + "api/taskmanagement/deletestandardtask",
  STANDARDTASK_DOWNLOAD_EXCEL:
    BASE_URL + "api/taskmanagement/standardtaskexcel",
  TSAKALLOCATION_DOWNLOAD_EXCEL:
    BASE_URL + "api/taskmanagement/taskallocationexcel",

  // Complete Task (SUB MODULE) ===========
  GET_LIST_OF_COMPLETE_TASK: BASE_URL + "api/taskmanagement/taskcompletionlist",
  ABORT_COMPLETE_TASK: BASE_URL + "api/taskmanagement/completetask",
  COMPLETETASK_DOWNLOAD_EXCEL:
    BASE_URL + "api/taskmanagement/taskcompletelistexcel",

  // Team Task (SUB MODULE) ===========
  TEAMTASK_DOWNLOAD_EXCEL: BASE_URL + "api/taskmanagement/teamtaskexcel",
  TEAMSHEET_YEAR: BASE_URL + "api/holiday/getyearslist",
  ACTIVATE_DEACTIVATE_TEAM: BASE_URL + 'api/teampreference/inactiveteam',

  // Project Task (SUB MODULE) ===========
  PROJECTTASK_DOWNLOAD_EXCEL: BASE_URL + "api/taskmanagement/projecttaskexcel",

  // Export File  (SUB MODULE) ===========
  DOWNLOAD_EXCEL_FILE: BASE_URL + "api/taskmanagement/excelformat",
  POST_EXCEL_FILE_FORMAT: BASE_URL + "api/taskmanagement/importexcel",

  // Client management APis
  GET_CLIENT_MANAG_LIST: BASE_URL + "api/projectclientmaster/getprjclientlist",
  ADD_CLIENT_DATA: BASE_URL + "api/projectclientmaster/client",
  EDIT_CLIENT_DATA: BASE_URL + "api/projectclientmaster/client",
  DELETE_CLIENT_BY_ID: BASE_URL + "api/projectclientmaster/deleteclient",
  GET_UPDATE_CLIENT_DATA: BASE_URL + "api/projectclientmaster/getclient",
  GET_PROJECT_LIST_DD: BASE_URL + "api/attendance/getprojectlist",
  CLIENTMANG_DOWNLOAD_EXCEL:
    BASE_URL + "api/projectclientmaster/clientexcelformat",
  GET_SERVICES: BASE_URL + "api/service/GetServices",
  GET_SERVICE_MAPPING_LIST:
    BASE_URL + "api/entities/branch/service/mappinglist/", //pass branchId
  CREATE_MAPPING: BASE_URL + "api/entities/branch/service/mapping",
  REMOVE_MAPPING_REC: BASE_URL + "api/entities/branch/service/remvoe",
  GET_PROJECT_LIST_BY_CLIENT:
    BASE_URL + "api/project/getprojectlistbyclient?ClientId=",

  // DAshboard Apis
  GET_INPROGRESS_DATA_LIST: BASE_URL + "api/dashboard/taskinprogress",
  GET_COMPLETED_DATA_LIST: BASE_URL + "api/dashboard/completetask",
  GET_TOTAL_WORK_HOURS: BASE_URL + "api/dashboard/gettotaltimesheethours",

  // Project module
  GET_MODAL_CLIENT_OPTIONS: BASE_URL + "api/project/getclientlist",
  GET_DEPARTMENT_MODAL_OPTIONS: BASE_URL + "api/project/getdepartmentlist",
  GET_ADMIN_NAMES_MODAL_OPTIONS: BASE_URL + "api/project/getemployeelist",
  GET_PROJECT_LIST: BASE_URL + "api/project/getprojectlist",
  ADD_PROJECT: BASE_URL + "api/project/addproject",
  POST_DATA_WITH_PROJECT_ID: BASE_URL + "api/project/editbyprojectid",
  DELETE_PROJECT: BASE_URL + "api/project/deleteproject",
  UPDATE_PROJECT: BASE_URL + "api/project/updateproject",
  GET_EMPLOYEE_NAMES_LIST: BASE_URL + "api/timesheet/employeenames",
  POST_EMPLOYEE_CREDENTIALS: BASE_URL + "api/timesheet/employeetimesheets",
  GET_PROJECTNAMES_LIST: BASE_URL + "api/timesheet/AllProjectNames",
  POST_TIMESHEET_DETAILS: BASE_URL + "api/timesheet/projecttimesheetbyteam ",
  //POST_TIMESHEET_DETAILS: BASE_URL + "api/project/getemployeeallocationlist",
  GET_OWNER_NAMES_MODEL_OPTIONS:
    BASE_URL + "api/project/getemployeeallocationlist",

  EMPTIME_DOWNLOAD_EXCEL:
    BASE_URL + "api/timesheet/employeetimesheetdetailexcel",
  PROTIME_DOWNLOAD_EXCEL:
    BASE_URL + "api/timesheet/projecttimesheetdetailsexcel",
  PROJRESOURCE_DOWNLOAD_EXCEL: BASE_URL + "api/project/projectresourceexcel",
  PROJRESOURCE_LIST_DOWNLOAD_EXCEL:
    BASE_URL + "api/project/projectrescourcelistexcel",
  PROJECT_DOWNLOAD_EXCEL: BASE_URL + "api/project/getprojectexcelsheet",
  GET_PROJECT_REPOS: BASE_URL + "api/project/getprojectrepositories?ProjectId=",
  // PROJECT DOCUMENTS
  GET_SALARY_SLIP: BASE_URL + PROJECT_PATH + "getsalaryslip",
  EMPLOYEE_CODE: BASE_URL + "me/document/addeditemployeecode",
  GET_EMPLOYEE_BY_ID: BASE_URL + "me/document/getemployeecode", // pass Id + OrgId
  UPLOAD_EMPLOYEE_DOCUMENT_BY_ADMIN: BASE_URL + "uploademployeedocumentbyadmin",
  GET_EMPLOYEE_DOCUMENT_BY_ADMIN: BASE_URL + "getemployeedocumentsbyadmin",
  UPDATE_DOCUMENT: BASE_URL + "editdocumentheading?documentId=",
  DELETE_DOCUMENT: BASE_URL + "deleteemployeedocument?documentId=",
  DOWNLOAD_DOCUMENT: BASE_URL + "downloademployeedocument?documentId=",

  // myDocument
  GET_EMPLOYEE_DOCUMENT: BASE_URL + "getemployeedocuments",
  UPLOAD_MY_DOCUMENT: BASE_URL + "uploademployeedocument",
  DELETE_MY_DOCUMENT: BASE_URL + "deleteemployeedocument?documentId=",
  DOWNLOD_MY_DOCUMENT: BASE_URL + "downloademployeedocument?documentId=",
  UPDATGE_MY_DOCUMENT: BASE_URL + "editdocumentheading?documentId=",
  GET_GENERATE_MY_SALARY_SLIP: BASE_URL + PROJECT_PATH + "generatemysalaryslip",
  // PROJECT DOCUMENTS

  // PROJETC SCHEDUL APIs
  GET_ASSIGNED_PROJECT_LIST: BASE_URL + PROJECT_PATH + "assignmentlist",
  GET_PROJECTS_NAMES: BASE_URL + PROJECT_PATH + "getprojectlist",
  GET_DROPDOWN_EMPLOYEE_NAMES: BASE_URL + PROJECT_PATH + "getemployeelist",
  ASSIGN_PROJECT: BASE_URL + PROJECT_PATH + "projectassingement",
  DEASSIGN_PROJECT: BASE_URL + PROJECT_PATH + "projectdeassigned",
  //project document
  UPLOAD_PROJECT: BASE_URL + PROJECT_PATH + "uploadprojectdocument",
  PROJECT_PROJECT: BASE_URL + PROJECT_PATH + "getprojectdocuments",
  PROJECT_LIST: BASE_URL + PROJECT_PATH + "getprojectdocuments",
  PROJECT_LIST_BYID:
    BASE_URL + PROJECT_PATH + "getprojectdocumentsbyprojectid?ProjectId=",
  PROJECT_DOCUMENT_DOWNLOAD:
    BASE_URL + PROJECT_PATH + "downloadprojectdocument?DocumentId=",
  PROJECT_DELETE: BASE_URL + PROJECT_PATH + "deleteprojectdocument?documentId=",
  PROJECT_LIST_DROPDOWN: BASE_URL + PROJECT_PATH + "getprojectlistdropdown",
  PROJECT_LINK_LIST: BASE_URL + PROJECT_PATH + "getprojectdocumentslinks",
  PROJECT_LINK_BYiD:
    BASE_URL + PROJECT_PATH + "getprojectdocumentslinksbyprojectid?ProjectId=",
  PROJECT_LINK_CREATE: BASE_URL + PROJECT_PATH + "createandupdatedocumentlink",
  PROJECT_LINK_DELETE:
    BASE_URL + PROJECT_PATH + "deletedocumentlink?DocumentId=",

  // COMPLIANCE MODULE APIs
  GET_DROPDOWNEMPLOYEE_LIST: BASE_URL + "compliance/teamnotassigndropdown",

  GET_TEAMNOTASSIGNEDLIST_DATA: BASE_URL + "compliance/teamnotassignedlist",
  GET_TEAMNOTASSIGNEDLIST_EXPORT:
    BASE_URL + "compliance/teamNotassignedlistexcelformat",

  GET_PROJECTNOTASSIGNED_LIST: BASE_URL + "compliance/projectnotassign",
  GET_PROJECTNOTASSIGNED_EXPORT:
    BASE_URL + "compliance/projectnotassignexcelsheet",

  GET_PROJECTASSIGNED_LIST: BASE_URL + "compliance/assignedlist",
  GET_PROJECTASSIGNED_EXPORT: BASE_URL + "compliance/assignedlistexcel",

  GET_PROJECTDEASSIGN_LIST: BASE_URL + "compliance/deassignedlist",
  GET_PROJECTDEASSIGN_LIST_EXPORT: BASE_URL + "compliance/DeAssignedListExcel",

  GET_TWOORMOREPROJECTS_LIST: BASE_URL + "compliance/morethantwoproject",
  GET_PROJECTNOTADDED_LIST: BASE_URL + "compliance/tasknotadded",
  GET_PROJECTNOTADDED_EXPORT: BASE_URL + "compliance/tasknotaddedexcel",

  GET_PROJECTNOTAPPROVED_LIST: BASE_URL + "compliance/tasknotapproved",
  GET_TASKNOTAPPROVED_EXPORT: BASE_URL + "compliance/tasknotapprovedexcel",

  GET_TIMESHEETNOTENTERED_LIST: BASE_URL + "compliance/timesheetnotentered",
  GET_TIMESHEETNOTENTERED_LIST_EXPORT:
    BASE_URL + "compliance/timesheetnotenteredexcel",

  GET_TIMESHEETNOTAPPROVED_LIST: BASE_URL + "compliance/timesheetnotapproved",
  GET_TIMESHEETNOTAPPROVED_EXPORT:
    BASE_URL + "compliance/timesheetnotapprovedexcel",

  GET_TIMEPERIODOVER_LIST: BASE_URL + "compliance/timeperiodover",
  GET_TIMEPERIODOVER_LIST_EXPORT: BASE_URL + "compliance/timeperiodoverexcel",

  GET_BENCHLIST_DATA: BASE_URL + "compliance/benchlist",
  GET_BENCHLIST_EXPORT: BASE_URL + "compliance/benchlistexcel",

  TEAMNOTAASIGN_DOWNLOAD_EXCEL:
    BASE_URL + "compliance/teamnotassignedlistexcelformat",

  TWOPLUSPROJ_DOWNLOAD_EXCEL: BASE_URL + "compliance/morethantwoprojectexcel",
  PROJ_DEASSIGN_DOWNLOAD_EXCEL: BASE_URL + "compliance/deassignedlistexcel",
  GET_WEEKLY_HOURS: BASE_URL + "api/attendance/getweeklyhours",

  // Compliance Setting Api
  GET_COMPLIANCE_SETTINGS: BASE_URL + COMPLIANCE + "getcompliancesettings",
  SET_COMPLIANCE_SETTINGS: BASE_URL + COMPLIANCE + "setcompliancesettings",
  SET_GENERIC_USERS: BASE_URL + COMPLIANCE + "setgenericusers",
  GET_GENERIC_USER_MAPPING: BASE_URL + COMPLIANCE + "getgenericusermapping/",

  // Project Costing
  GET_DROPDOWNTEAMNAME_LIST: BASE_URL + "api/project/teamnames",
  GET_DESIGNATIONDD_LIST: BASE_URL + "api/project/designationsname",
  POST_COST_DATA: BASE_URL + "api/project/addemployeecosting",
  GET_EMPLOYEE_LIST: BASE_URL + "api/project/costinglist",
  GET_DATA_WITH_ID: BASE_URL + "api/project/getbyidcost",
  POST_UPDATE_COST: BASE_URL + "api/project/updatecosting",
  DELETE_SINGLE_DATA: BASE_URL + "api/project/deletecost",
  GET_PROJECTFORECAST_LIST: BASE_URL + "api/project/projectcostingreport",
  POST_WITH_ID_FORCAST: BASE_URL + "api/project/getprojectforcast",
  GET_EMPLOYEE_SALARY_STRUCTURE: BASE_URL + PROJECT_PATH + "employeestructure",
  ADD_UPDATE_SALARY_STRUCTURE: BASE_URL + PROJECT_PATH + "addsalarystructure",
  DELETE_SALARY_STRUCTURE: BASE_URL + PROJECT_PATH + "deletesalarystructure",
  GET_SALARY_DATA: BASE_URL + PROJECT_PATH + "generatesalaryslip",
  GENERATE_SALARY_SLIP: BASE_URL + PROJECT_PATH + "generatepdfsalaryslip",
  Salary_Master_Roll: BASE_URL + "api/attendance/salaryregister?",
  GITLABURL:
    "https://chat.wifiattendance.com:3015/webhook/gitlab-url?schannel_id=",
  Resignation: BASE_URL + "resignation",
  // https://api.wifiattendance.com/api/project/generatepdfsalaryslip

  // https://api.wifiattendance.com/api/project/generatesalaryslip?EmpId=4966&Months=april&year=2023

  // TeamPreference
  CREATE_TEAM: BASE_URL + "api/teampreference/createteam",
  TEAM_HEAD_lIST: BASE_URL + "api/attendance/getemployeesnames",
  GET_TEAM_LIST: BASE_URL + "api/teampreference/getteamlist",
  UPDATE_TEAM: BASE_URL + "api/teampreference/updateteams",
  ADD_MEMBER:
    BASE_URL +
    "api/teampreference/addmember?EmployeeId=${EmployeeId}&TeamId=${teamId}",
  MANAGE_TEAM_DOWNLOAD_EXCEL: BASE_URL + "api/teampreference/teamslistexcel",
  DELETE_TEAMLIST: BASE_URL + "api/teampreference/deleteteam/",

  // Holiday and calendar API's
  GET_HOLIDAYS_LIST: BASE_URL + HOLIDAY_PATH + "getholidaylist",
  CREATE_HOLIDAY: BASE_URL + HOLIDAY_PATH + "create",
  GET_HOLIDAY: BASE_URL + HOLIDAY_PATH + "getholiday",
  DELETE_HOLIDAY: BASE_URL + HOLIDAY_PATH + "delete",
  UPDATE_HOLIDAY: BASE_URL + HOLIDAY_PATH + "modify",
  GET_LOCATION: BASE_URL + "getlocations",

  // Compliance
  GETDEPARTMENT_LIST: BASE_URL + "api/project/getdepartmentlist",
  DESIGNATION_NAME: BASE_URL + "api/project/designationsname",
  ROLES_LIST: BASE_URL + "api/roles/getroles",
  GET_LOCATION: BASE_URL + "getlocations",
  GET_SHIFT_LIST: BASE_URL + "getshifts",

  GET_USER_NOTLOGIN: BASE_URL + "getusernotlogin",
  GET_USER_NOTLOGIN_EXPORT: BASE_URL + "GetUserNotloginexport",

  GET_USER_LASTLOGIN: BASE_URL + "UserLastLogin",
  GET_USER_LASTLOGIN_EXPORT: BASE_URL + "UserLastLoginExport",

  GET_USER_ACTIVITY: BASE_URL + "UserActivityHistory",
  GET_USER_ACTIVITY_EXPORT: BASE_URL + "UserActivityExport",

  //Employee
  ACTIVE_EMPLOYEE_LIST: BASE_URL + "activeemployees",
  EMPLOYE_ADDED: BASE_URL + "employeeadd",
  DEACTIVE_EMP_LIST: BASE_URL + "getdeactiveuser",
  IMPORT_EMPLOYEE: BASE_URL + "importemployeesfromexcel",
  Excel_User: BASE_URL + "exporttoexceluser",
  DELETE_USER: BASE_URL + "deleteuser",
  USER_PROFILE_WORK_DETAILS:
    BASE_URL + "api/myprofile/getemployeeworkdetails?employeeId=",
  EMPLOYEE_DELETE: BASE_URL + "deleteUser",
  //Timesheet Management
  DOWNLOAD_TIMESHEET_EXCEL: BASE_URL + "api/timesheet/timesheetexcel",

  // Years

  GET_YEARS: BASE_URL + "api/attendance/dynamic/years",
  GET_MONTH: BASE_URL + "api/attendance/dynamic/months?Year=",

  //EMPLOYEE MANAGMENT
  EMPLOYEELIST_DOWNLOAD_EXCEL: BASE_URL + "activeemployeesexcel",
  DEACTIVE_EMPLOYEELIST_DOWNLOAD_EXCEL: BASE_URL + "deactivateuserexcel",

  //General Settings
  CHANGE_PASSWORD_BY_ADMIN: BASE_URL + "api/authentication/changepassword",
  GET_ADDONS_LIST: BASE_URL + 'api/admin/getalladdonlist',
  ENABLE_DISABLE_ADDON: BASE_URL + 'api/admin/toggleaddon',

  // organetion
  GET_DESIGNEGETION_LIST: BASE_URL + "api/designationmaster/getdesignationlist",
  ADD_DESIGNEGETION: BASE_URL + "api/organization/createdesignation",
  DELETE_DESIGNEGETION: BASE_URL + "api/organization/deletedesignation?id={id}",
  GET_DEPARMENT_LIST: BASE_URL + "api/organization/getdepartmentlist",
  ADD_DEPARTMENT: BASE_URL + "api/departmentmaster/createdepartment",
  UPDATE_DEPARMENT: BASE_URL + "api/organization/departmentmodify",
  DELETE_DEPARMENT: BASE_URL + "api/departmentmaster/deletedepartment/",
  GET_LOCATION: BASE_URL + "api/organization/location",
  ADD_UPDATE_LOCATION: BASE_URL + "api/organization/createlocation",
  EMPLOYEESlIST: BASE_URL + "api/attendance/getemployeesnames",
  DELETE_LOCATION: BASE_URL + "api/organization/deletelocation?id={id}",
  GET_ORGANISATION: BASE_URL + "api/organization/getorganization",
  UPDATE_ORGANIZATIONS: BASE_URL + "api/organization/organizationmodify",

  // payment get way
  PAYMENTGETWAY: BASE_URL + "api/organization/gatewaymaster/",
  PAYMENTGETDETAILS: BASE_URL + "api/organization/getpaymentsettings/",
  UPDATEPAYMENT: BASE_URL + "api/organization/updatepaymentsettings",

  // SMS GETWAY
  SMSGETWAYDETAILS: BASE_URL + "api/organization/getsmssettings/",
  UPDATESMS: BASE_URL + "api/organization/updatesmssettings",

  // IVR GETWAY
  IvrSeriver: "api/get-master-ivr",
  //  AddIvr: "http://192.168.1.20:3016/" + "api/addUpdateIvrService",
  AddIvr: BASE_URL_Offoce_caller + "api/addUpdateIvrService",
  IVRDetalis: "api/ivr-services",

  //chart
  CHART: BASE_URL + "api/organization/getorganisationchart",
  // WhatsApp Settings
  GETWHATSAPPLIST: "api/WA-Setting?",
  GETWHATSAPPDETAILS: "api/WA-Setting/",
  GETWHATSAPPADD: "api/WA-Setting",
  GETWHATSAPPUPDATE: "api/WA-Setting",
  GETWHATSAPPDELETE: "api/WA-Setting/",
  // IVR
  GETIVRLIST: "api/get-ivr-users/",
  GETIVRLISTSHOW: "api/get-ivr/",
  ADDTIVR: "api/add-ivr",
  UpdateTIVR: "api/update-ivr/",
  ADDTIVREDITVIEW: "/api/get-ivr/",
  DELETERIVER: "api/delete-ivr/",

  // BulkUpload
  BULK_UPLOAD: BASE_URL_Offoce_caller + "api/bulk-user-upload",

  // Chat bot Admin
  GET_DOMAINS: BASE_URL_CHATADMIN + "api/domains",
  GET_TEST_CASES: BASE_URL_CHATADMIN + "api/test-case-by-id?",
  GET_COLOR_SETTING_BY_DOMAINS:
    BASE_URL_CHATADMIN +
    "api/GetColorSettingsByDomain?domain=https://appcostcalculator.redbytes.co.uk",
  POST_ADD_COLOR_SETTING: BASE_URL_CHATADMIN + "api/color-settings/",
  GET_COLOR_SETTING_BY_ID: BASE_URL_CHATADMIN + "api/color-settings/",
  UPDATE_COLOR_SETTING: BASE_URL_CHATADMIN + "api/color-settings/",
  GET_COLOR_SETTING_LIST: BASE_URL_CHATADMIN + "api/color-settings",
  DELETE_COLOR_SETTING: BASE_URL_CHATADMIN + "api/color-settings/",
  MODULE_LIST: BASE_URL_CHATADMIN + "api/modules-wise-count?domain_id=",
  UPDATE_DISPLAY_NAME: BASE_URL_CHATADMIN + "api/update-module-display",
  AUTO_UPDATE_MODULES: BASE_URL_CHATADMIN + "api/auto-update-modules",
  GET_SUB_MODULE_LIST: BASE_URL_CHATADMIN + "api/submodules-wise-count?", // pass domainid And moduleName
  GET_SUB_MODULE_report: BASE_URL_CHATADMIN + "api/generate-submodule-report", // pass domainid And moduleName
  UPDATE_SUB_MODULE_DISPLAY_NAME:
    BASE_URL_CHATADMIN + "api/update-subModule-display",
  LOAD_NEW_PERMISSION: BASE_URL_CHATADMIN + "api/load-chatbot-permissions",
  UPDATE_SAB_TOPIC: BASE_URL_CHATADMIN + "api/update-topic-display",
  CHATBOTAIURL: "https://chatbot-api.cloudxperte.com/webhooks/rest/webhook",
  CHATBOTSUCCES: BASE_URL_CHATADMIN + "api/intent-wise-test-case",
  // questions
  ADD_QUESTIONS: BASE_URL_CHATADMIN + "api/question?domain_id=",
  GET_QUESTION_LIST: BASE_URL_CHATADMIN + "api/question",
  GET_QUESTION_BY_ID: BASE_URL_CHATADMIN + "api/question/",
  PUT_UPDATE_QUESTION_BY_ID: BASE_URL_CHATADMIN + "api/question/",
  GET_ASSISTANTS: BASE_URL_CHATADMIN + "api/assistants",
  GENARATE_API_KEY: BASE_URL_CHATADMIN + "api/generateAPIKey/",
  DELETE_QUESTION: BASE_URL_CHATADMIN + "api/question/", //id
  GET_UN_ANSWERED_QUES: BASE_URL_CHATADMIN + "api/nores-question-list",
  DELETE_UN_ANSWERED_QUES: BASE_URL_CHATADMIN + "api/delete-nores-question/", //id
  GET_MULTIPLE_QUESTION: BASE_URL_CHATADMIN + "api/get-multiple-questions",
  IMPORT_ANSERS_LIST: BASE_URL_CHATADMIN + "api/import-chat-bot",
  GET_MODULE_LIST_DROP_DOWN: BASE_URL_CHATADMIN + "api/get-module-names",
  ADD_KEYWORD: BASE_URL_CHATADMIN + "api/keyword-add",
  GET_MODULE_LIST: BASE_URL_CHATADMIN + "api/get-module-list",
  DELETE_KEYWORD: BASE_URL_CHATADMIN + "api/keyword-delete?module_id=",
  UPDATE_KEYWORD: BASE_URL_CHATADMIN + "api/keyword-update",
  DOWNLOAD_KEYWORD: BASE_URL_CHATADMIN + "api/update-mapping-keywords",
  GET_COUNTS: BASE_URL_CHATADMIN + "api/modules-wise-count?id=",
  GET_FEEDBACK_USER: BASE_URL_CHATADMIN + "api/list-user-like-unlike?",
  GET_Module_STATIC: BASE_URL_CHATADMIN + "api/module-test-count/?domain_id=",
  EXPORT_QUESTIONS: BASE_URL_CHATADMIN + "api/get-multiple-questions?",
  GET_SUB_Module_STATIC: BASE_URL_CHATADMIN + "api/submodule-test-count/",
  EXPORT_QUESTIONS_BY_MODULE: BASE_URL_CHATADMIN + "api/import-chat-bot",
  // GET_FEEDBACK_USER: BASE_URL_CHATADMIN + 'api/list-user-like-unlike?',

  // Login

  // Chat

  GET_CHAT_USERS: BASE_URL_CHATADMIN + "api/chatbot-users",
  TEST_CASE_LIST: BASE_URL_CHATADMIN + "api/test-case-list",
  TEST_CASE_IMPORT: BASE_URL_CHATADMIN + "api/import-test-cases",
  TEST_CASE_GET:
    BASE_URL_CHATADMIN + "api/test-case-fetch-by-id/?test_case_id=",
  TEST_CASE_DELETE:
    BASE_URL_CHATADMIN + "api/test-case-delete-by-id/?test_case_id=",
  TEST_CASE_UPDATE: BASE_URL_CHATADMIN + "api/test-case-update",
  TEST_EXPORT: BASE_URL_CHATADMIN + "api/export-test-case",

  // Permissions

  GET_PERMISSIONS_LIST:
    BASE_URL_CHATADMIN + "api/chatbot-permissions?domain_id=",
  UPDATE_PERMISSION: BASE_URL_CHATADMIN + "api/chatbot-permissions",
  GET_TOPICS: BASE_URL_CHATADMIN + "api/topic-list?",
  GET_LIKE_UNLIKE_LIST:
    BASE_URL_CHATADMIN + "api/list-preference-like-unlike?domain_id=",

  // offce caller CRM
  GET_WEEK_CALL: OFFECE_CALLER_BASE_URL + "api/week-call-summary/",
  CALL_DESHBOARD: OFFECE_CALLER_BASE_URL + "api/dashboard-data/",
  INTERNATIONAL_DESHBOARD:
    OFFECE_CALLER_BASE_URL + "api/dashboard_international/",
  GET_AGENTS_LIST: OFFECE_CALLER_BASE_URL + "api/agent-list/",
  GET_ZERO_CALL_LIST: OFFECE_CALLER_BASE_URL + "api/zero_call_list/?page=",
  GET_FREQUENT_CALL_LIST: OFFECE_CALLER_BASE_URL + "api/frequently_call/",
  GET_CALL_LIST: OFFECE_CALLER_BASE_URL + "api/distress-case-call-list",
  GET_USER_LIST: OFFECE_CALLER_BASE_URL + "api/user-list/?page=",
  GET_WHATSAPP_SETTINGS: OFFECE_CALLER_BASE_URL + "api/whatsapp-setting/",
  ADD_WHATSAPP_SETTINGS_DATA:
    OFFECE_CALLER_BASE_URL + "api/whatsapp_token_create/",
  UPDATE_WHATSAPP_SETTING:
    OFFECE_CALLER_BASE_URL + "api/whatsapp_token_update/?id=",
  DELETE_WHATSAPP_SETTING_DATA:
    OFFECE_CALLER_BASE_URL + "api/whatsapp_token_delete/?id=",
  GET_CALL_CLASSIFICATION: OFFECE_CALLER_BASE_URL + "api/call_classification/",
  GET_USER_DETAILS: OFFECE_CALLER_BASE_URL + "api/user-details/",
  UPDATE_AGENT_DETAILS: OFFECE_CALLER_BASE_URL + "api/update-user-details/",
  // GET_COUNTRY_LIST: OFFECE_CALLER_BASE_URL + "api/get_country_list/",
  GET_STATE_LIST: OFFECE_CALLER_BASE_URL + "api/get-state-list/",
  GET_CITY_LIST: OFFECE_CALLER_BASE_URL + "api/get-city-list/",
  USER_REGITRATION: OFFECE_CALLER_BASE_URL + "api/users-register/",
  GET_USER_LIST: OFFECE_CALLER_BASE_URL + "api/user-list/",
  GET_ZERO_CALL_DATA: OFFECE_CALLER_BASE_URL + "api/zero_call_list/",
  GET_FREQUEN_CALLER_LIST: OFFECE_CALLER_BASE_URL + "api/frequently_call/",
  GET_SERVICE_REQUEST: OFFECE_CALLER_BASE_URL + "api/service_request/",
  GET_CANDITEDE_DATA: OFFECE_CALLER_BASE_URL + "api/upload_old_candidate/",
  GET_ALL_CANDITED_DATA: OFFECE_CALLER_BASE_URL + "api/candidate-data/",
  RESSINGING_CANDEDET: OFFECE_CALLER_BASE_URL + "api/bulk-call/",
  CALL_REPORTS: OFFECE_CALLER_BASE_URL + "api/type-call-report/?call_type=",
  TECHNOLOGY_COUNT: OFFECE_CALLER_BASE_URL + "api/technology_count/",
  GET_CALL_HISTRORY: OFFECE_CALLER_BASE_URL + "api/call-history/",
  INTERNATIONAL_CALL_ASSING:
    OFFECE_CALLER_BASE_URL + "api/assign_call_users_international/",
  MAKE_CALL: OFFECE_CALLER_BASE_URL + "api/make_call/",
  // agent_priority
  ADD_AGENT_PRIORITY: OFFECE_CALLER_BASE_URL + "api/add_agent_priority/",
  GET_AGENT_lIST_DATA: OFFECE_CALLER_BASE_URL + "api/agent_list_data/",
  AGENT_PRIORITY: OFFECE_CALLER_BASE_URL + "api/agent_priority/",
  AGENT_CALL_REPORTS: OFFECE_CALLER_BASE_URL + "api/agent-call-reports/",
  DEAILY_CALL_HISTORY: OFFECE_CALLER_BASE_URL + "api/daily-call-history/",
  GET_AGENT_CALL_SUMMARY: OFFECE_CALLER_BASE_URL + "api/weekly-call-history/",
  // WHATSAPP_PROMOTIONS
  CREATE_GROUP: BASE_URL_Offoce_caller + "api/promotion-groups",
  USER_LIST: BASE_URL_Offoce_caller + "api/getUserList",
  GROUPlIST: BASE_URL_Offoce_caller + "api/promotion-groups",
  SOURCELIST: BASE_URL_Offoce_caller + "api/getpromotionSources",
  TEMPLETELIST: BASE_URL_Offoce_caller + "api/getpromotionTemplates/",
  CREATE_PROMOTION: BASE_URL_Offoce_caller + "api/promotional-messages",
  GET_PROMOTION_LIST: BASE_URL_Offoce_caller + "api/promotional-messages",
  GET_PROMOTION_DETAILS_BY_ID:
    BASE_URL_Offoce_caller + "api/promotional-messages/",
  CANCLE_PROMOTION: BASE_URL_Offoce_caller + "api/cancelPromotionMessage/",
  // node api for phoneBook
  CONSULTANT_AND_SUPPLIER: BASE_URL_CHATADMIN + "api/mark_users",
  GET_INTENT_DROPDOWN: BASE_URL_CHATADMIN + "api/test-case-dropdown?domain_id=",
  TEST_CASE_ADD: BASE_URL_CHATADMIN + "api/test-case-add",
  GET_UN_ANSWERED_TEST_LIST: BASE_URL_CHATADMIN + "api/list-no-test-case?",
  NO_RESPONSE_QUES: BASE_URL_CHATADMIN + "api/add-nores-question",
  GENERATE_AI_QUES_ANS: BASE_URL_CHATADMIN + 'api/generate-chatbot-questions',

  // workflow
  REGISTER_CLIENT: BASE_URL + "api/workflowclient/register",
  GET_CLIENTS: BASE_URL + "api/client/getclients?",
  UPDATE_CLIENT: BASE_URL + "api/workflowclient/modify",
  CREATE_ENTITY: BASE_URL + "api/entities/create",
  GET_SINGLE_ENTITY: BASE_URL + "api/entities/",
  GET_ENTITIES_LIST: BASE_URL + "api/entities/getcliententities?clientId=",
  UPDATE_ENTITY: BASE_URL + "api/entities/modify",
  CREATE_BRANCH: BASE_URL + "api/entities/branch/create",
  GET_BRANCH_LIST: BASE_URL + "api/entities/branch/getall?entityId=",
  GET_SINGLE_BRANCH: BASE_URL + "api/entities/branch/",
  UPDATE_BRANCH: BASE_URL + "api/entities/branch/modify",
  DELETE_BRANCH: BASE_URL + "api/entities/branchdelete/",
  CREATE_BANK: BASE_URL + "api/entities/branch/bank/create",
  UPDATE_BANK: BASE_URL + "api/entities/branch/bank/modify",
  GET_BANKS_LIST: BASE_URL + "api/entities/branch/bank/getall?branchid=",
  GET_BANK_DETAILS: BASE_URL + "api/entities/branch/bank/", // pass id
  CREATE_SHIFT: BASE_URL + "api/entities/branch/shift/create",
  UPDATE_SHIFT: BASE_URL + "api/entities/branch/shift/modify",
  GET_SUBSCRIPTIONS: BASE_URL + "api/subscription/getpendingsubscriptions",
  GET_NEW_ENTITY_FOR_TRGGER:
    BASE_URL + "api/workflow/GetWorkflowDataforTrigger",
  SUBS_TRIGGER: BASE_URL + "api/subscription/trigger/",
  NEW_ENTITY_TRIGGER: BASE_URL + "api/workflow/",
  VERIFY_OTP_WORKFLOW: BASE_URL + "api/workflowclient/verifyotp",
  GET_TASK_ALLOCATION_STATUS: BASE_URL + "api/tasks/allocationstatuses",
  GET_PENDING_SUBSCRIPTIONS:
    BASE_URL + "api/subscription/getpendingsubscriptionsforworkflow",
  CREATE_WORKFLOW: BASE_URL + "api/workflow/creates",
  GET_WORKFLOWS: BASE_URL + "api/workflow/getworkflows",
  GET_WORKFLOW_BY_ID: BASE_URL + "api/workflow/",
  UDPATE_WORKFLOW: BASE_URL + "api/workflow/update",
  GET_TASK_DETAILS: BASE_URL + "api/tasks/gettaskdetails?AllocationId=",
  GET_DYNAMIC_FIELDS_FOR_TASK: BASE_URL + "api/tasks/allocation",
  SUBMIT_DYNAMIC_TASK: BASE_URL + "api/tasks/submittaskdata",
  UPLOAD_FILE: BASE_URL + "api/tasks/",
  GET_pREVIES_TASKS_LIST: BASE_URL + "api/tasks/getcompletedtasks",
  GET_ALL_WORKFLOW: BASE_URL + "api/workflow/getallworkflowsmaster?active=",
  CREATE_WORKFLOW_MAPPING: BASE_URL + "api/workflow/createworkflowmapping",
  CREATE_WORKFLOW_MASTER: BASE_URL + "api/workflow/createsmaster",
  UPDATE_WORKFLOW_MASTER: BASE_URL + "api/workflow/updatemaster",
  GET_WORKFLOW_BY_ID_MAPPING:
    BASE_URL + "api/workflow/getworkflowmappingbyid?Id=",
  UPDATE_WORKFLOW_MAPPING: BASE_URL + "api/workflow/updateworkflowmapping",
  GET_PENING_INPROGEES_TASK_COUNT:
    BASE_URL + "api/taskmanagement/countofpendingworkflowtask",
  GET_WORKFLOW_CHART: BASE_URL + "api/workflow/getworkflowchart",
  GET_PERIOD_BY_TYPES: BASE_URL + "api/service/getperiodsbytype?Type=",

  // Quotation
  GETQUOTATIONLIST: BASE_URL + "api/quotation/getquotationbyclientid?ClientId=",
  GET_CONSULTANTS: BASE_URL + "api/users/getconsultants",
  GET_CLIENTS_WORKFLOW: BASE_URL + "api/client/getall",
  GET_BRANCH_BY_CLIENT: BASE_URL + "api/client/", // id/branches
  CREATE_QUOTAION: BASE_URL + "api/quotation/create",
  GET_QUOTATIONS: BASE_URL + "api/quotation/getallquotations",
  GET_SINGLE_QUOTATION: BASE_URL + "api/quotation/", // pass Id
  UPDATE_QUOTATION: BASE_URL + "api/quotation/modify",
  UPDATE_QUATATION_STATUS: BASE_URL + "api/quotation/quoteupdate/",
  SEND_QUOTATION_MAIL: BASE_URL_CHAT + "/quotation",
  GET_ALL_SUBSCRIPTION: BASE_URL + "api/subscriptionsmaster/getall",
  GET_SINGLE_SUBSCRIPTION: BASE_URL + "api/subscriptionsmaster/getbyid/",
  GET_SERVICES_BY_GROUP_ID:
    BASE_URL + "api/service/getservicesbygroupid?GroupId=",
  GET_SUBSCRIPTION_BY_SERVICE_ID:
    BASE_URL + "api/subscriptionsmaster/getbyserviceid/",
  CONVERT_CURRENCY: BASE_URL + "api/quotation/currencyconvert?",

  // Subscription Api
  ADD_SUBCSRIPTION: BASE_URL + "api/subscriptionsmaster/create",
  GET_SUBSCRIPTIONS_LIST: BASE_URL + "api/subscriptionsmaster/getall",
  GET_SUBSCRIPTIONS_DETAILS_BYID: BASE_URL + "api/subscriptionsmaster/getbyid/",
  UPDATE_SUBSCRIPTIONS: BASE_URL + "api/subscriptionsmaster/edit",
  ACTIVE_SUBSCRIPTIONS: BASE_URL + "api/subscriptionsmaster/activedeactive/",

  ACCEPT_TASK_BY_WORKFLOW: BASE_URL + "api/tasks/accepttaskbyid?Id=",
  COMPLETED_WORKFLOWA_LIST:
    BASE_URL + "api/workflow/getworkflowsallocation?uid=",
  RESUME_WORKFLOW: BASE_URL + "api/workflow/setstatusworkflowsallocation?id=",
  COMPLETED_WORKFLOW_TASK_LIST: BASE_URL + "api/tasks/CompletedTasks/",
  COMPLETED_WORKFLOW_TASK_RESUME: BASE_URL + "api/tasks/setstatustaskbyid?id=",
  CLIENT_ACTIVE_DEACTIVE: BASE_URL + "api/client/active/",
  GET_WORKFLOW_DESHBOARD: BASE_URL + "api/workflow/getdashboarddata?userId=",
  WORKFLOW_TASK_FORM: BASE_URL + "api/taskmanagement/workflowtaskform",

  //Member List Api
  GET_MEMBERLIST: BASE_URL + "api/workflowclient/clientuserlist?",
  CREATE_MEMBER: BASE_URL + "api/client/registeruser",
  ACTIVEINACTIVE_MEMBER: BASE_URL + "api/workflowclient/clientuseractive?",
  UPDATE_MEMBER: BASE_URL + "api/client/registeruser",
  // lywo

  LOGIN_WITH_UNIQUE_CODE: BASE_URL + "api/Account/GetUniqueCodeJobDetails",
  REGISTRATION_FORM: BASE_URL + "api/Account/AutheriseEmailAddCandidate",
  ASSESMENT_TEST:
    BASE_URL + "api/Assessment/GetAssessmentQustionsWithPreviousAnswers",
  TOKEN_ACCESS: BASE_URL + "api/Account/GetToken",
  ADD_ASSESSMENT_RESULT: BASE_URL + "api/Assessment/SubmitAssessment",
  ASSESSMENT_PICTURE: BASE_URL + "api/Assessment/GetImage/",
  GET_SPECIALIZATIONS: BASE_URL + "api/CommonDropDown/GetSpecializations",
  SUBMIT_ADDITIONINFO:
    BASE_URL + "api/CandidateMgmt/AddEditCandidateAdditionaldtls",
  GET_ADDITIONINFO: BASE_URL + "api/CandidateMgmt/GetAdditionalDtls",
  GET_LANG: BASE_URL + "api/Account/GetLanguagePreference?UserId=",
  UPDATE_LANG: BASE_URL + "api/Account/UpdateLanguagePreference?",
  GET_CUSTOM_QUESTIONS: BASE_URL + "api/Organization/GetCustomQuestion",
  GET_INDUSTRY_LIST: BASE_URL + "api/Organization/GetIndustryList",

  ACCESS_CODE_LIST: BASE_URL + "api/CandidateMgmt/AdminUniqueCodeUserdtls?",
  GET_OTP_WITH_EMAIL: BASE_URL + "api/Account/AdminAuthorizeEmail",
  LOGIN_WITH_VALID_OTP: BASE_URL + "api/Account/AdminValidatedOTP",
  DOWNLOAD_EXCEL:
    BASE_URL + "api/CandidateMgmt/ExportUniqueCodeUserDetails?code=", // pass code
  GROUP_LIST: BASE_URL + "api/CandidateMgmt/GetCodeAccessDtls?email=",
  ADD_JOB: BASE_URL + "api/Job/Insertjobcode",
  GET_CODE_DETAILS: BASE_URL + "api/Job/GetJobCodeDetails?jobcode=",
  DELETE_USER_AND_DEP: BASE_URL + "api/User/DeleteUserAndDependencies?",
  EXCELDOWNLOADFILE:
    BASE_URL + "api/Assessment/GenerateExcel/generateExcel?UserId=",
  GET_AREA_OF_EDUCATION:
    BASE_URL + "api/CommonDropDown/GetSpecializations?currentUserId=1",
  GET_INDUSTRY_LIST: BASE_URL + "api/Organization/GetIndustryList",
  SEND_ASSESSMENT_REMINDER: BASE_URL + "api/Assessment/SendAssessementReminder",
  GET_LAST_EMAIL_CONTENT: BASE_URL + "api/Assessment/GetLastEmailContent",
  SELECT_STATUS: BASE_URL + "api/CandidateMgmt/UpdateSatus",
  GET_EMAIL_CONTENT: BASE_URL + "api/Assessment/GetEmailContent",
  GENERATE_CANDIDATE_EXCEL:
    BASE_URL + "api/Assessment/GenerateCandidateAnswersExcel?CodeId=",
  GET_AUTHENTICATED_SENDERS:
    BASE_URL + "api/Assessment/GetAuthenticatedSenders",
  GET_USER_TRAITS: BASE_URL + "getusertraits?empId=",

  // PRiston

  GET_PROFILE_DETAILS: BASE_URL + ENTITY_PATH + "getcompanyprofile",
  UPDATE_COMPANY_PROFILE: BASE_URL + ENTITY_PATH + "updatecompanyprofile",

  LOGIN: BASE_URL + LOGIN_PATH + "authenticate",
  SALESGOOD: BASE_URL + INVOICE_PATH + "savetaxinvoice",
  SALESSERVICE: BASE_URL + INVOICE_PATH + "saveserviceinvoice",
  PURCHASEGOOD: BASE_URL + PURCHASE_PATH + "savepurchinvoice",
  PURCHASESERVICE: BASE_URL + PURCHASE_PATH + "saveserviceinvoice",
  GET_INVOICENO: BASE_URL + INVOICENO_PATH + "generateinvno",
  GET_STATES: BASE_URL + INVOICE_PATH + "getstates",
  GET_PRODUCTS: BASE_URL + PRODUCT_PATH + "getproducts",
  GET_PRODUCT_DETAILS: BASE_URL + PRODUCT_PATH + "getproductdetails",
  GET_SERVICES_LIST_API: BASE_URL + 'api1/productspriston/getservicedetails',
  GET_SALES_INVOICE_TAX_DATA: BASE_URL + INVOICE_PATH + "getinvdetails",
  GET_PURCHASE_INVOICE_TAX_DATA: BASE_URL + PURCHASE_PATH + "getinvdetails",
  REGISTER_USER: BASE_URL + REGISTER_PATH + "createaccount",
  GET_PROFILE_DATA: BASE_URL + ADMIN_PATH + "companyprofile",
  GET_INVOICE_LIST: BASE_URL + PURCHASE_PATH + "getpurchaseinvoices",
  GET_CUSTOMER_INVOICES: BASE_URL + INVOICE_PATH + "getcustomerinvoices",
  GET_CUSTOMER_INVOICES_PURCHASE:
    BASE_URL + PURCHASE_PATH + "GetPurchaseInvoices",
  FETCH_PAYMENT_TERMS: BASE_URL + INVOICE_PATH + "GetPaymentTerms",

  FORGOT_PASSWORD: BASE_URL + REGISTER_PATH + "forgetpassword",
  CHANGE_PASSWORD: BASE_URL + REGISTER_PATH + "changeuserpassword",
  SAVE_BUSINESS_DETAILS: BASE_URL + REGISTER_PATH + "saveorgdetails",
  ADD_NEW_PRODUCT: BASE_URL + PRODUCT_PATH + "addproduct",
  GET_HSNCODE: BASE_URL + PRODUCT_PATH + "hsncodelist",
  GET_ACCOUNT: BASE_URL + ACCOUNT_PATH + "getledgeraccid",
  GET_SALES_REPORT: BASE_URL + PURCHASE_PATH + "getpurchasereport",
  GET_PURCHASE_REPORT: BASE_URL + PURCHASE_PATH + "getpurchasereport",
  GET_UNITS: BASE_URL + INVOICE_PATH + "getunits",
  OTP_VARIFICATION: BASE_URL + CLIENT_PATH + "getclientotp",

  GET_SALES_GOODS_INVOICE_LIST: BASE_URL + INVOICE_PATH + "goodsinvlist",
  GET_SALES_SERVICE_INVOICE_LIST: BASE_URL + INVOICE_PATH + "serviceinvlist",
  UPDATE_SALES_GOODS_INVOICE: BASE_URL + INVOICE_PATH + "modifytaxinvoice",

  GET_PURCHASE_GOODS_INVOICE_LIST: BASE_URL + PURCHASE_PATH + "goodsinvlist",
  GET_PURCHASE_SERVICE_INVOICE_LIST:
    BASE_URL + PURCHASE_PATH + "serviceinvlist",
  UPDATE_PURCHASE_INVOICE: BASE_URL + PURCHASE_PATH + "modifypurchinvoice",
  UPDATE_PURCHASE_INVOICE: BASE_URL + PURCHASE_PATH + "modifypurchinvoice",

  // EXPENSE MODULE
  EXPENSE_GST: BASE_URL + EXPENSE_PATH + "expensegst",
  EXPENSE_NON_GST: BASE_URL + EXPENSE_PATH + "expensenongst",
  GET_EXPENSE_GST_SEARCH_RESULT: BASE_URL + EXPENSE_PATH + "expensegstsearch",
  GET_EXPENSE_NONGST_SEARCH_RESULT:
    BASE_URL + EXPENSE_PATH + "expensenongstsearch",
  GET_EXPENSE_GST_PREVIEW: BASE_URL + EXPENSE_PATH + "expensegstpreview",
  GET_EXPENSE_NONGST_PREVIEW: BASE_URL + EXPENSE_PATH + "expensenongstpreview",
  INCOME_GST: BASE_URL + INCOME_PATH + "incomegst",
  INCOME_NON_GST: BASE_URL + INCOME_PATH + "incomenongst",
  SEARCH_INCOME_INVOICES: BASE_URL + INCOME_PATH + "incomegstsearch",
  SEARCH_INCOME_NON_GST_INVOICES: BASE_URL + INCOME_PATH + "incomenongstsearch",
  GET_INCOME_PREVIEW: BASE_URL + INCOME_PATH + "incomegstpreview",

  // INCOME MODULE
  GET_INCOME_NONGST_PREVIEW: BASE_URL + INCOME_PATH + "incomenongstpreview",
  SEARCH_PURCHASE_INVOICES: BASE_URL + PURCHASE_PATH + "getpurchaseinvoices",
  GET_CUSTOMER_NAMES: BASE_URL + INVOICE_PATH + "customer/nameslist",
  GET_CUSTOMER_BILLING_DATA: BASE_URL + INVOICE_PATH + "customername",
  GET_GSTIN_DETAILS: BASE_URL + INVOICE_PATH + "getgstin",

  // =============================== POST INVOICES MODULE =============================== //
  EINVOICE_POST_GOV_PORTAL: BASE_URL + INVOICE_PATH + "einv",
  CANCEL_EINVOICE: BASE_URL + INVOICE_PATH + "canceleinvoice",

  EWAYBILL_POST_GOV_PORTAL: BASE_URL + INVOICE_PATH + "ewaybill",
  // =============================== POST INVOICES MODULE =============================== //
  POST_EINVOICES: BASE_URL + INVOICE_PATH + "post-einvoice",

  // =============================== POSTED INVOICES MODULE =============================== //
  //E-Invoices
  POSTED_EINVOICES: BASE_URL + INVOICE_PATH + "posted-einvoice",
  EINVOICE_PREVIEW: BASE_URL + INVOICE_PATH + "einvoice-preview",

  //E-Way Bills
  POSTED_EWAYBILLS: BASE_URL + INVOICE_PATH + "posted-ewaybill",
  EWAYBILL_PREVIEW: BASE_URL + INVOICE_PATH + "ewaybill-preview",
  // =============================== POSTED INVOICES MODULE =============================== //
  // /api/invoice/ewaybill-preview/15
  // http://18.188.42.141:8085/api/invoice/posted-ewaybill

  // INVOICE SETTINGS APIs
  GET_INVOICE_TYPES: BASE_URL + INVOICE_SETTINGS + "getinvoicetypes",
  GET_DOCUMENT_DETAILS: BASE_URL + INVOICE_SETTINGS + "getdocdetails",
  UPDATE_INVOICE_NUMBERING: BASE_URL + INVOICE_SETTINGS + "updatedocnumbers",
  GET_GENERAL_SETTINGS: BASE_URL + INVOICE_SETTINGS + "getsettings",
  UPDATE_SETTINGS: BASE_URL + INVOICE_SETTINGS + "updatesettings",

  // GST INVOICE SETTINGS
  ADD_GST_SETTINGS: BASE_URL + INVOICE_SETTINGS + "addgstsettings",
  GET_GST_SETTING: BASE_URL + INVOICE_SETTINGS + "getgstsettings",

  // FINANCIAL YEAR SETTINGS
  FETCH_FINANCIAL_YEAR_LIST: BASE_URL + ENTITY_PATH + "finyear",
  SET_FINANCIAL_YEAR: BASE_URL + ENTITY_PATH + "setfinyear",

  // INVOICE_SETTLEMENT
  ADD_BANK_ACCOUNT: BASE_URL + INVOICE_PATH + "addbankaccount",
  IMPORT_BANK_STATEMENT: BASE_URL + INVOICE_PATH + "importbankstatement",
  DOWNLOAD_EXCEL_SALES_GOODS: BASE_URL + INVOICE_PATH + "exportgoodsinvexcel",
  DOWNLOAD_EXCEL_SALES_SERVICE:
    BASE_URL + INVOICE_PATH + "ExportServiceInvExcel",

  DOWNLOAD_EXCEL_PURCHASE_SERVICE: BASE_URL + PURCHASE_PATH + "ServiceInvExcel",
  DOWNLOAD_EXCEL_PURCHASE_GOODS: BASE_URL + PURCHASE_PATH + "goodsInvExcel",

  DOWNLOAD_EXCEL_SALES_REPORT: BASE_URL + INVOICE_PATH + "salesreportexport",
  DOWNLOAD_EXCEL_PURCHASE_REPORT:
    BASE_URL + PURCHASE_PATH + "Purchasereportexport",

  DOWNLOAD_EXCEL_POSTEINVOICE: BASE_URL + INVOICE_PATH + "ExportPostEinvoice",

  // ERP MANAGEMENT
  CREATE_MASTER_SERVICE: BASE_URL + "api1/productspriston/addservicemaster",
  CREATE_MATERIAL_MASTER: BASE_URL + "api1/productspriston/addmaterialmaster",
  CREATE_FINISHED_GOOD_MASTER:
    BASE_URL + "api1/productspriston/addfinishedgoodsmaster",
  CREATE_BUNDLE: BASE_URL + "api1/productspriston/addbundlemaster",
  CREATE_WAREHOUSE: BASE_URL + "api1/warehouse/addwarehousemaster",
  CREATE_VENDOR_CUSTOMER: BASE_URL + "api1/customer/addcustomermaster",
  GET_VENOR_CUSTOMER: BASE_URL + "api1/customer/getcustomermasters?type=",
  GET_WAREHOUSES: BASE_URL + "api1/warehouse/getwarehousemasters",
  CREATE_PURCHASE_ORDER: BASE_URL + "api1/purchaseorder/addpurchaseorder",
  CREATE_SALES_ORDER: BASE_URL + "api1/salesorder/addsalesorder",
  GET_CURRENCY_LIST: BASE_URL + "api/settings/getcurrencies",

  //TaSk Planner

  GET_TASK_PLANNER_DATA: BASE_URL_CHAT + "/task/assess-task",
  PUBLISH_TASK_PLANNER: BASE_URL + "api/workflow/taskplanner?",
  GET_TASK_PLANER_LIST: BASE_URL + "api/workflow/taskplanner/0",
  GET_TASK_PLANER: BASE_URL + "api/workflow/taskplanner/task/", //id

  // AI AGENT SETTINGS APIs
  GET_ALL_AI_AGENTS: BASE_URL + "api/settings/getallaiagents",
  GET_AI_AGENT_BY_ID: BASE_URL + "api/settings/getaiagentbyid",
  CREATE_AI_AGENT: BASE_URL + "api/settings/createaiagent",
  UPDATE_AI_AGENT: BASE_URL + "api/settings/updateaiagent",
  DELETE_AI_AGENT: BASE_URL + "api/settings/deleteaiagent",

  // AI AGENT MAPPING APIs
  GET_ALL_AI_AGENT_MAPPINGS: BASE_URL + "api/settings/getallaiagentmappings",
  GET_AI_AGENT_MAPPING_BY_ID: BASE_URL + "api/settings/getaiagentmappingbyid",
  CREATE_AI_AGENT_MAPPING: BASE_URL + "api/settings/createaiagentmapping",
  UPDATE_AI_AGENT_MAPPING: BASE_URL + "api/settings/updateaiagentmapping",
  DELETE_AI_AGENT_MAPPING: BASE_URL + "api/settings/deleteaiagentmapping",

  // EMPLOYEES BY TYPE
  GET_EMPLOYEES_BY_TYPE: BASE_URL + "getemployeesbytype",
};

export default ApiConfig;
